// style imports
import './NoDataFound.css';

const NoDataFound = ({src}) => {
  return (
    <div className='no_data_found mues_row_center'>
        {src && <img src={src} alt="no-data-found" loading='lazy' />}
        <p className='mues_font_weight_500 mues_grey_II'>No Data Found</p>
    </div>
  )
}

export default NoDataFound